import { client } from '../../../services/apiClient';
import { TagsResponse } from '../../../models/tags/TagsResponse';

export const TAGS_ENDPOINT = '/tags';

export const getTags = async (projectId: number): Promise<TagsResponse[]> => {
  if (isNaN(projectId)) {
    return [];
  }

  const { data } = await client(true, true).get<TagsResponse[]>(`${TAGS_ENDPOINT}/${projectId}`);
  return data;
};

export const deleteTag = async (tagId: number, projectId: number): Promise<void> => {
  return client(true, true)
    .delete<TagsResponse[]>(`${TAGS_ENDPOINT}/${tagId}/${projectId}`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const updateTag = async (tagData: Partial<TagsResponse>): Promise<void> => {
  return client(true, true)
    .put<TagsResponse[]>(`${TAGS_ENDPOINT}`, tagData)
    .then((response) => response.data)
    .catch((error) => error);
};
